import {
  createSlice,
  createSelector
} from '@reduxjs/toolkit'

import ActivityFactory from '@polleverywhere/core/lib/activity_factory'
import JoinInstructions from '../../models/join_instructions'
import URI from 'urijs'
import { pluralize } from '@polleverywhere/core/lib/util'

const sliceName = 'app-viz'
const selectors = {}
const thunks = {}

selectors.activityAsModel = createSelector(
  (state) => state.activity,
  (activity) => {
    if (activity === null) {
      return null
    }

    if (activity?.id === 'join_instructions') {
      return new JoinInstructions({
        presenter_shared_key: 'JoinInstructions'
      })
    }

    return ActivityFactory(Object.assign({}, activity))
  }
)

selectors.urlPath = createSelector(
  (state) => state.activity,
  (activity) => {
    if (activity) {
      const type = activity.type
      const key = activity.presenter_key || activity.permalink

      if (!type || !key) {
        return false
      }

      return URI(pluralize(2, type))
        .segment(key)
        .toString()
    }

    return false
  }
)

const initialState = {
  activity: undefined
}

const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    fullReset (state) {
      return initialState
    },
    requestedJoinInstructions (state) {
      return { ...state, activity: { id: 'join_instructions' } }
    },
    changedActivity (state, action) {
      return { ...state, activity: action.payload }
    },
    requestedActivityDoesntExist (state) {
      return { ...state, state: null }
    }
  }
})

const sliceExport = {
  name: slice.name,
  reducer: slice.reducer,
  ...slice.actions,
  ...selectors,
  ...thunks
}

export { sliceExport as slice }
